module.exports = __webpack_public_path__ + "static/media/team-introduction-1.a4ff36e2.jpg";